const THEME_MODES = ['light', 'dark', 'system']
const SYSTEM_DARK_QUERY = '(prefers-color-scheme: dark)'

export const createThemeController = ({ rootSelector, initMode = 'system' }) => {
  let currentMode = THEME_MODES.includes(initMode) ? initMode : 'system'

  const resolveTheme = (mode) => {
    if (mode !== 'system') {
      return mode
    }

    return window.matchMedia(SYSTEM_DARK_QUERY).matches ? 'dark' : 'light'
  }

  const setMode = (mode) => {
    if (!THEME_MODES.includes(mode)) {
      return false
    }

    currentMode = mode

    const resolvedTheme = resolveTheme(mode)
    const themeRoot = document.querySelector(rootSelector)

    if (themeRoot) {
      themeRoot.dataset.theme = resolvedTheme
      themeRoot.dataset.themeMode = mode
      themeRoot.style.colorScheme = resolvedTheme
    }

    return true
  }

  const init = () => {
    const systemThemeQuery = window.matchMedia(SYSTEM_DARK_QUERY)

    const handleSystemThemeChange = () => {
      if (currentMode === 'system') {
        setMode('system')
      }
    }

    systemThemeQuery.addEventListener('change', handleSystemThemeChange)

    setMode(currentMode)

    return () => {
      systemThemeQuery.removeEventListener('change', handleSystemThemeChange)
    }
  }

  return {
    init,
    setMode,
    getMode: () => currentMode
  }
}
